import { FC } from 'react'
import { FieldArrayPath } from 'react-hook-form'

import { InputGroup } from '@revolut-internal/ui-kit'

import { Security } from 'modules/security/security'
import { AlertingPolicyCreateRequest } from 'types'

import { QueueHealthPolicyItem } from '../QueueHealthPolicyItem'
import { useQueueHealthPolicy } from '../QueueHealthPolicyProvider'

import { QueueHealthPolicyThresholdCondition } from './QueueHealthPolicyThresholdCondition'
import { QueueHealthPolicyThresholdMetrics } from './QueueHealthPolicyThresholdMetrics'
import { QueueHealthPolicyThresholdSlackUserGroups } from './QueueHealthPolicyThresholdSlackUserGroups'

type QueueHealthPolicyThresholdProps = {
  fieldName: FieldArrayPath<AlertingPolicyCreateRequest>
  index: number
  allowsDelete: boolean
  onDelete: VoidFunction
}

export const QueueHealthPolicyThreshold: FC<QueueHealthPolicyThresholdProps> = ({
  fieldName,
  index,
  allowsDelete,
  onDelete,
}) => {
  const { users, userGroups, metrics, isRefreshingUserGroups } = useQueueHealthPolicy()
  const isReadonly = !Security.canCreatePolicy

  return (
    <QueueHealthPolicyItem
      instance="rule"
      allowsDelete={allowsDelete}
      isReadonly={isReadonly}
      onDelete={onDelete}
    >
      <InputGroup>
        <QueueHealthPolicyThresholdMetrics
          index={index}
          fieldName={fieldName}
          metrics={metrics}
        />
        <QueueHealthPolicyThresholdCondition
          index={index}
          fieldName={fieldName}
          metrics={metrics}
        />
        <QueueHealthPolicyThresholdSlackUserGroups
          index={index}
          fieldName={fieldName}
          users={users}
          userGroups={userGroups}
          isPending={isRefreshingUserGroups}
        />
      </InputGroup>
    </QueueHealthPolicyItem>
  )
}
